import { memo } from 'react'

import { useNavigate, ParsePathParams } from '@tanstack/react-router'

import { SnackPanelActions, SnackPanelActionsProps, ViewSpace } from '@shared/components/Snackbar'
import { useHotkeys } from '@shared/utils/hooks'
import { SnackPanelActionButtonLink } from 'components/LinkedMUIComponents'
import { imageBlobsOverviewRoute } from 'pages/NWPlatform/Workspaces/Workspace/Images/Image/Blobs/Routing'

type SuccessPanelActionsProps = Record<ParsePathParams<typeof imageBlobsOverviewRoute.fullPath>, string>

const SuccessPanelActionsRaw = ({
  onClose,
  buttonDefaultProps: _,
  ...routeParams
}: SuccessPanelActionsProps & SnackPanelActionsProps) => {
  const navigate = useNavigate()

  useHotkeys([
    [
      'space',
      () => {
        navigate({ to: imageBlobsOverviewRoute.to, params: routeParams })
        onClose()
      },
    ],
  ])

  return (
    <SnackPanelActions>
      <SnackPanelActionButtonLink to={imageBlobsOverviewRoute.to} params={routeParams} onClick={() => onClose()}>
        <ViewSpace />
      </SnackPanelActionButtonLink>
    </SnackPanelActions>
  )
}

export const SuccessPanelActions = memo(SuccessPanelActionsRaw)
